import {Multimedia} from '@/types/matrix';
import {Box, Card, CardMedia} from '@mui/material';

import VideoPreviewWithPlayIcon from '@/components/matrix-chat/ui/video-preview-with-play-icon';
interface BoxWithThreeElementsProps {
  urls: string[];
  multimediaType: Multimedia;
  handleOpenFullScreen: (url: string) => void;
}
const BoxWithThreeElements: React.FC<BoxWithThreeElementsProps> = ({
  urls,
  multimediaType,
  handleOpenFullScreen
}) => {
  const cardProps = {
    height: '100%'
  };

  const cardMediaProps = {
    cursor: 'pointer',
    objectFit: 'cover',
    height: '100%'
  };

  const isVideo = multimediaType === 'video';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        //gap: '5px',
        maxWidth: {xs: '200px', md: '300px'},
        maxHeight: {xs: '100px', md: '200px'}
      }}
    >
      <Box
        sx={{
          height: {xs: '100px', md: '200px'},
          width: {xs: '100px', md: '200px'}
        }}
      >
        <Card
          sx={{
            ...cardProps
          }}
        >
          {isVideo ? (
            <VideoPreviewWithPlayIcon
              url={urls[0]}
              handleOpenFullScreen={handleOpenFullScreen}
            />
          ) : (
            <CardMedia
              component="img"
              image={urls[0]}
              alt={`First ${multimediaType}`}
              onClick={() => handleOpenFullScreen(urls[0])}
              sx={{...cardMediaProps}}
            />
          )}
        </Card>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          //gap: '5px',
          height: '200px'
        }}
      >
        {urls.slice(1, 3).map((url, index) => (
          <Box
            key={url}
            sx={{
              height: {xs: '50px', md: '100px'},
              width: {xs: '50px', md: '100px'}
            }}
          >
            <Card sx={cardProps}>
              {isVideo ? (
                <VideoPreviewWithPlayIcon
                  url={urls[index + 1]}
                  handleOpenFullScreen={handleOpenFullScreen}
                />
              ) : (
                <CardMedia
                  component="img"
                  image={urls[index + 1]}
                  alt={`${multimediaType} ${index + 2}`}
                  onClick={() => handleOpenFullScreen(urls[index + 1])}
                  sx={cardMediaProps}
                />
              )}
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BoxWithThreeElements;
